import { render, staticRenderFns } from "./NoticePreviewView.vue?vue&type=template&id=37e8ed51&scoped=true"
import script from "./NoticePreviewView.ts?vue&type=script&lang=ts&external"
export * from "./NoticePreviewView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8ed51",
  null
  
)

export default component.exports